import { StyleSheet, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  titleText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  root: {
    paddingVertical: 10,
  },
  subtitle: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
    paddingTop: 4,
  }),
  price: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  itemTitle: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  collapsedItem: {
    paddingVertical: 10,
    paddingLeft: 32,
  },
  collapsedItemContainerTopBottom: {
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderBottomColor: Colors.veryLightPinkTwo,
    borderTopColor: Colors.veryLightPinkTwo,
  },
  collapsedItemContainerTop: {
    borderTopWidth: 1,
    borderTopColor: Colors.veryLightPinkTwo,
  },
  beforeTitleLabel: theme => ({
    color: theme.colors.textColorTwo,
  }),
  additionalInfoContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  icon: {
    marginStart: 5,
    marginTop: -5,
  },
  longPrice: {
    flex: 1,
    textAlign: 'right',
  },
  longTextTitleView: {
    flex: Platform.OS === 'ios' ? 1.5 : 2,
    zIndex: 1,
  },
});
